export const POST_ERROR_MESSAGE = 'Error while posting post.';
export const CATEGORY_CREATE_ERROR = 'Something went wrong.';
export const CATEGORY_EDIT_ERROR = 'Something went wrong.';
export const SUCCESS_TOAST = text => `${text} successfully.`;
export const ITEM_CREATE_SUCCESS = 'Item Created Successfully.';
export const ITEM_EDIT_SUCCESS = 'Item Edited Successfully.';
export const ITEM_CREATE_ERROR = 'Something went wrong.';
export const ITEM_EDIT_ERROR = 'Something went wrong.';
export const ITEM_DELETE_ERROR = 'Something went wrong.';
